export const locale = {
    lang: 'pl',
    data: {
        'Workers': 'Pracownicy',
        'Groups': 'Grupy',
        'Operators': 'Salony',
        'Devices': 'Urządzenia',
        'Device groups': 'Grupy urządzeń',
        'Customer source': 'Źródła klientów',
        'Vat rates': 'Stawki podatkowe',
        'Resources': 'Zasoby',
        'Settings': 'Ustawienia',
        'Voucher templates': 'Szablony karnetów',
        'Actions': 'Akcje',
        'Public API access': 'Dostęp do API publicznego',
        'Message templates': 'Szablony wiadomości',
        'Marketing vouchers': 'Vouchery marketingowe',
        'Notification accounts': 'Konta providerów powiadomień',
        'Marketing actions': 'Akcje marketingowe',
    }
};
